export const DEFAULT_THEME_PRIMARY_COLOR = '#0078D4';
export const ACCEPTED_COLOR = '#00AD56';
export const TENTATIVE_COLOR = '#767676';
export const CONFLICT_COLOR = '#D13438';
export const ACCESSIBILITY_BREAKING_BACKGROUND_COLORS = ['#000000', '#5D5A58']; //Values hardcoded into bigOWA, where the user can choose different categories apart from the default provided on Shoreline.
export const WHITE_BACKGROUND_COLOR = '#ffffff';
export const DEFAULT_DARK_MODE_COLOR = '#121212';
